import React from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

export default class PrintButtons extends React.Component {
  constructor(props) {
    super(props)
  }

  renderCreateTableButton() {
    if (this.props.onCreateTable !== null){
      let {createTableTitle} = this.props
      return (
        <Button
          bsStyle='primary'
          onClick={this.props.onCreateTable}
        >
          <FontAwesome name='table' />{' '}{createTableTitle}
      </Button>
      )
    }
    return ''
  }

  renderPrintSlip() {
    if (this.props.onPrintSlip !== null)
      return (
        <Button
          bsStyle={null}
          className='bg-maroon'
          onClick={this.props.onPrintSlip}
        >
          <FontAwesome name='print' />{' '}พิมพ์สลิป
      </Button>
      )
    return ''
  }

  renderPrintSlipDetail() {
    if (this.props.onPrintSlipDetail !== null)
      return (
        <Button
          bsStyle={null}
          className='bg-maroon'
          onClick={this.props.onPrintSlipDetail}
        >
          <FontAwesome name='print' />{' '}พิมพ์สลิปละเอียด
      </Button>
      )
    return ''
  }

  renderPrintTable() {
    if (this.props.onPrintTable !== null)
      return (
        <Button
          bsStyle={null}
          className='bg-maroon'
          onClick={this.props.onPrintTable}
        >
          <FontAwesome name='print' />{' '}พิมพ์ตาราง
        </Button>
      )
    return ''
  }

  renderExportExcel() {
    if (this.props.onExportExcel !== null)
      return (
        <Button
          bsStyle={null}
          className='bg-green'
          onClick={this.props.onExportExcel}
        >
          <FontAwesome name='file-excel-o' />{' '}ออกไฟล์Excel
        </Button>
      )
    return ''
  }

  render() {
    return (
      <div style={{ width: this.props.width,  marginLeft: this.props.marginLeft }}>
        <ButtonToolbar>
          {this.renderCreateTableButton()}
          {this.renderPrintSlip()}
          {this.renderPrintSlipDetail()}
          {this.renderPrintTable()}
          {this.renderExportExcel()}
        </ButtonToolbar>
      </div>
    )
  }
}

PrintButtons.defaultProps = {
  onCreateTable: null,
  onPrintSlip: null,
  onPrintSlipDetail:null,
  onPrintTable: null,
  onExportExcel: null,
  createTableTitle:'สร้างตาราง',
  width:'640px',
  marginLeft:'20px'
}


// WEBPACK FOOTER //
// ./src/component/element/PrintButtons.js